export const CATEGORIES_LIST_SUCCESS = 'CATEGORIES_LIST_SUCCESS'
export const CATEGORIES_LIST_FAIL = 'CATEGORIES_LIST_FAIL'

export const CATEGORIES_ADMIN_LIST_SUCCESS = 'CATEGORIES_ADMIN_LIST_SUCCESS'
export const CATEGORIES_ADMIN_LIST_FAIL = 'CATEGORIES_ADMIN_LIST_FAIL'

export const CATEGORIES_UPDATE_STATUS_SUCCESS = 'CATEGORIES_UPDATE_STATUS_SUCCESS'
export const CATEGORIES_UPDATE_STATUS_FAIL = 'CATEGORIES_UPDATE_STATUS_FAIL'
export const CATEGORIES_UPDATE_STATUS_RESET = 'CATEGORIES_UPDATE_STATUS_RESET'